import { render, staticRenderFns } from "./submission_panel.vue?vue&type=template&id=502e01c8&scoped=true&"
import script from "./submission_panel.vue?vue&type=script&lang=ts&"
export * from "./submission_panel.vue?vue&type=script&lang=ts&"
import style0 from "./submission_panel.vue?vue&type=style&index=0&id=502e01c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502e01c8",
  null
  
)

export default component.exports